'use strict';

/* eslint no-sync: 0 */

import angular from 'angular';

export class sidenavComponent {
  constructor(GLOBALS, common, $timeout, Auth) {
    'ngInject';
    this.common = common;
    this.version = GLOBALS.vno;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isModerator = Auth.isModeratorSync;
    this.isOrgadmin= Auth.isOrgadminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
  }
}

export default angular.module('culturefitApp.sidenav', [])
  .component('sidenav', {
    template: require('./sidenav.html'),
    controller: sidenavComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidenav/sidenav.component.js